import Base from './base';

class Tags extends Base {
    getAll = (query) => this.getRequest('/guest/tag', query)
    addNew = data => this.postRequest('/tag', data)
    delete = (id) => this.deleteRequest(`/tag/${id}`)
}

export default new Tags();
